module.exports = __webpack_public_path__ + "static/Savage_Outdoor_Defense_Logo_White-15856316ecf2058b41870b94869763ab.png";